module.exports = __webpack_public_path__ + "static/media/esfera-stadium.20eff9b6.png";